import React from 'react'

import Image from 'shared/components/common/Image'
import { t, Trans } from 'src/translations'

const TTOPromo = () => {
  return (
    <div className='promoContainer'>
      <div className='promoImg'>
        <Image
          alt={t('tto-promo.app-on-phone')}
          src='toastLocal/splash/toast-takeout-native-app-362.jpg'
        />
      </div>
      <div className='promoContent'>
        <h2>{t('tto-promo.order-from')}</h2>
        <h3>{t('tto-promo.download-local')}</h3>

        <a
          href='https://apps.apple.com/us/app/local-by-toast/id1362180579'
          rel='nofollow'
          className='button-gray iosButton'
        >
          {t('tto-promo.ios')}
        </a>
        <a
          href='https://play.google.com/store/apps/details?id=com.toasttab.consumer&hl=en_US'
          rel='nofollow'
          className='button-gray androidButton'
        >
          {t('tto-promo.android')}
        </a>

        <div className='dinerSupport'>
          <Trans
            i18nKey='tto-promo.issue-with'
            components={[<a key='0' href='mailto:dinersupport@toasttab.com' />]}
          />
        </div>
      </div>
    </div>
  )
}

export default TTOPromo
